import Vue from 'vue'
const axios = require('axios');

const state = {
    mode: 'search',
    loading: false,
    active_project: false,
    active_study: false,
    active_pdf: false,

	enable_notification: true,
	notifications: [],

}

const getters = {
    mode(state) { return state.mode },
    active_project(state) { return state.active_project },
    active_study(state) { return state.active_study },
    active_pdf(state) { return state.active_pdf },
    notifications: state => state.notifications,
    loading: state => state.loading
}

const actions = {
    toggle_mode({ commit, state, dispatch }) {
        var mode = 'search'
        if (state.mode == 'search') {
            mode = 'home'
            // dispatch('load_projects_by_type');
        } else {
            dispatch('load_projects_v2', { mode: mode });
        }
        commit('SET_MODE', { mode: mode })
    },
    set_active_pdf({ commit, state }, data) {
        commit('SET_ACTIVE_PDF', { active_pdf: data.active_pdf })
    },
    toggle_active_project({ commit, state }, data) {
        if (data.project == state.active_project) {
            commit('SET_ACTIVE_PROJECT', { project: null });
        }
        else {
            commit('SET_ACTIVE_PROJECT', { project: data.project });
            if (data.project.etudes) commit('SET_ACTIVE_STUDY', { study: _.last(data.project.etudes) });
        }
    },
    toggle_active_study({ commit, state }, data) {
        commit('SET_ACTIVE_STUDY', { study: data.study });
    },

    load_study: function({ commit, state}, data) {
        commit('EDIT_STUDY', { study: data.study, url: data.study.pdfLien })
    },

    // Affiche ou non le chargement de l'app
    set_loading({ commit, state }, data) {
        commit('SET_LOADING', { loading: data.loading })
    },

	add_notification: function({ commit, state }, data) {
		if (state.enable_notification) {
			commit('ADD_NOTIFICATION', { notification: data })
			setTimeout(function() {
				commit('REMOVE_NOTIFICATION', { notification: data })
			}, 5000)
		}
	},

	remove_notification: function({ commit }, data) {
		commit('REMOVE_NOTIFICATION', { notification: data.notification })
	},
	

}
const mutations = {
    SET_ACTIVE_PDF(state, data) {
        state.active_pdf = data.active_pdf
    },
    SET_LOADING(state, data) {
        state.loading = data.loading
    },
    SET_MODE(state, data) {
        state.mode = data.mode
    },
    SET_ACTIVE_PROJECT(state, data) {
        Vue.set(state, 'active_project', data.project)
    },
    SET_ACTIVE_STUDY(state, data) {
        Vue.set(state, 'active_study', data.study)
    },
    EDIT_STUDY(state, data) {
        if (data.study) {
            for (var i in data) {
                if (i != 'study') {
                    Vue.set(data.study, i, data[i])
                }
            }
        }
    },

	SET_ENABLE_NOTIFICATION: function(state, data) {
		state.enable_notification = data.enable
	},

	ADD_NOTIFICATION: function(state, data) {
		if (!data.notification.id) data.notification.id = _.uniqueId('notification-')
		state.notifications.push(data.notification)
	},

	REMOVE_NOTIFICATION: function(state, data) {
		var index = _.indexOf(state.notifications, data.notification)
		state.notifications.splice(index, 1)
	},


}

export default { state, getters, actions, mutations }